import Phaser from 'phaser';

/** First scene: minimal, hands straight off to Preload. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('boot');
  }

  create(): void {
    this.scene.start('preload');
  }
}
